import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("bp-scripture-callout")
export class ScriptureCallout extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin: var(--size-2) 0;
    }

    ::slotted(p) {
      margin: 0 !important;
    }

    ::slotted(bp-caption) {
      padding: var(--size-1);
      font-size: inherit;
      background-color: var(--color-neutral-05);
      border-radius: var(--radius-md);
    }

    figure {
      display: flex;
      flex-direction: column;
      gap: var(--size-1);
      box-shadow: inset var(--size-1) 0 0 -5px var(--color-neutral-10);
      padding: 0 0 0 var(--size-2);
      margin: 0;
      line-height: var(--line-height-normal);
    }

    header {
      display: flex;
      gap: var(--size-1);
    }

    footer {
      color: var(--color-gray);
      font-size: var(--font-size-xs);
    }

    .reference {
      font-weight: var(--font-weight-bold);
    }

    .translation {
      color: var(--color-gray);
      font-size: var(--font-size-xs);
      font-weight: var(--font-weight-semibold);
      vertical-align: 4px;
    }
  `;

  @property()
  reference?: string;

  @property()
  translation?: string;

  @property()
  footnote?: string;

  render() {
    return html`
      <figure>
        <header>
          ${this.reference &&
          html` <span class="reference">${this.reference}</span> `}
          ${this.translation &&
          html` <span class="translation">${this.translation}</span> `}
        </header>

        <slot></slot>

        ${this.footnote && html` <footer>${this.footnote}</footer> `}

        <slot name="caption"></slot>
      </figure>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-scripture-callout": ScriptureCallout;
  }
}
